import { render, staticRenderFns } from "./flight_item_info.vue?vue&type=template&id=cd93233a&"
import script from "./flight_item_info.vue?vue&type=script&lang=js&"
export * from "./flight_item_info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports